export const GET_EVENTS = 'GET_EVENTS'
export const GET_EVENT = 'GET_EVENT'
export const CREATE_EVENT = 'CREATE_EVENT'
export const UPDATE_EVENT = 'UPDATE_EVENT'
export const DELETE_EVENT = 'DELETE_EVENT'
export const DELETE_MANY_EVENTS = 'DELETE_MANY_EVENTS'
export const GET_EVENT_GALLERY = 'GET_EVENT_GALLERY'
export const ADD_GALLERY_PHOTO = 'ADD_GALLERY_PHOTO'
export const DELETE_GALLERY_PHOTO = 'DELETE_GALLERY_PHOTO'
export const UPDATE_EVENT_PERMISSIONS = 'UPDATE_EVENT_PERMISSIONS'
export const SEND_EVENT_NOTIFICATION = 'SEND_EVENT_NOTIFICATION'
